<template>
	<module class="m-notice m-module" :title="title">
		<div ref="scroll" class="content-box flex-grow">
			<div ref="content" class="content" :class="{'z-scroll': noticeScroll}" :style="{'animation-duration': noticeScroll / 20 + 's'}">
				<div v-html="content"></div>
				<div v-if="noticeScroll" v-html="content"></div>
			</div>
		</div>
	</module>
</template>

<script>
	import module from './digital_module.vue'

	export default {
		components: {
			module
		},

		props: {
			id: [Number, String]
		},

		data() {
			return {
				title: '',
				content: '',
				noticeScroll: false
			}
		},
		
		mounted() {
			this.update();
		},
		
		beforeDestroy() {
			clearTimeout(this._updateTimer);
		},

		methods: {
			update() {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						this.title = data.childModule.title;
						this.content = data.childModule.content;
						this.noticeScroll = false;
						this.$nextTick(() => {
							let promise = [];
							this.$refs.content.querySelectorAll('img').forEach(item => {
								promise.push(new Promise(resolve => {
									item.onload = resolve;
									item.onerror = resolve;
								}));
							});
							Promise.all(promise).then(() => {
								this.noticeScroll = this.$refs.content.clientHeight > this.$refs.scroll.clientHeight ? this.$refs.content.clientHeight : 0;
							});
						});
						this._updateTimer = setTimeout(this.update, 3600000);
					},
					fail: () => {
						this._updateTimer = setTimeout(this.update, 3600000);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-notice {
		.content {
			line-height: .24rem;
			font-size: .14rem;
			color: #B7ECFF;

			&.z-scroll {
				animation: noticeScroll 5s infinite linear;
			
				@keyframes noticeScroll {
					0% {
						transform: translate(0,0);
					}
					100% {
						transform: translate(0,-50%);
					}
				}

				> div {
					padding-bottom: 1rem;
				}
			}

			&-box {
				margin: 0 .2rem .2rem;
				overflow: hidden;
			}

			>>> img {
				max-width: 100%;
			}
		}
	}
</style>
